module.exports = __webpack_public_path__ + "static/media/2.712ec959.jpg";